/*首页*/
import * as API from './'

export default {

  /*获取token*/
  get_query:params =>{
    return API.GET(BASEURL + '/api/v1/getToken', params)
  },

  /*地图下钻*/
  getMapData:params =>{
    return API.POST(BASEURL + '/api/v1/areaImage/getMapData', params)
  },

  /*区划下钻*/
  areaDrillDown: params => {
    return API.GET(BASEURL + '/api/v1/area/areaDrillDown', params)
  },


  /*区划下钻*/
  areaDetail: params => {
    return API.GET(BASEURL + '/api/v1/area/areaDetail', params)
  },



  /*设备汇总信息*/
  getDeviceCollect: params => {
    return API.POST(BASEURL + '/api/v1/areaImage/getDeviceCollect', params)
  },


  /*设备列表*/
  getDeviceList: params => {
    return API.POST(BASEURL + '/api/v1/areaImage/getDeviceList', params)
  },

  /*设备详情*/
  getDeviceInfo: params => {
    return API.GET(BASEURL + '/api/v1/areaImage/getDeviceInfo', params)
  },


  /*根据设备id或时间（可选）返回一个设备的最新情况*/
  getrealtimeInfo: params => {
    return API.GET(BASEURL + '/api/v1/weather/getrealtimeInfo', params)
  },


  /*今日气象*/
  getTodayInfo: params => {
    return API.GET(BASEURL + '/api/v1/weather/getTodayInfo', params)
  },

  /*近一周气象*/
  getWeekInfo: params => {
    return API.GET(BASEURL + '/api/v1/weather/getWeekInfo', params)
  },

  /*近一月气象*/
  getMonthInfo: params => {
    return API.GET(BASEURL + '/api/v1/weather/getMonthInfo', params)
  },

  /*近三月气象*/
  get3MonthInfo: params => {
    return API.GET(BASEURL + '/api/v1/weather/get3MonthInfo', params)
  },

  /*查看作业轨迹详情*/
  get_gj_detail: params => {
    return API.POST(BASEURL + '/api/v1/work/detail', params)
  },

  /*轨迹线列表*/
  get_gj_list: params => {
    return API.POST(BASEURL + '/api/v1/work/list', params)
  },

  /*近一周轨迹*/
  statweeksinfo: params => {
    return API.GET(BASEURL + '/api/v1/work/statweeksinfo', params)
  },

  /*近一月轨迹*/
  statmonthinfo: params => {
    return API.GET(BASEURL + '/api/v1/work/statmonthinfo', params)
  },

  /*近三月轨迹*/
  stat3monthinfo: params => {
    return API.GET(BASEURL + '/api/v1/work/stat3monthinfo', params)
  },


  /*设备列表点位图*/
  getDeviceSpotList: params => {
    return API.POST(BASEURL + '/api/v1/areaImage/getDeviceSpotList', params)
  },

  /*设备列表点位图*/
  get_gj_record: params => {
    return API.POST(BASEURL + '/api/v1/work/record', params)
  },

  /*获取视频播放地址*/
  get_gj_record: params => {
    return API.GET(BASEURL + '/api/v1/camera/getCameraNetAddress', params)
  },


}



// WEBPACK FOOTER //
// ./src/api/api_home_page.js